// =============================================================================
// FILE:
// src/modules/pms/task_material/services/taskMaterialReturnService.js
// =============================================================================

import axiosClient from "../../../../api/axiosClient";

// =============================================================================
// CREATE MATERIAL RETURN
// =============================================================================

export const createMaterialReturn = async (

  payload

) => {

  const response = await axiosClient.post(

    "/api/pms/task-material-return/create",

    payload
  );

  return response.data;
};